import { fetcherModeAtom, currentUserQuery } from "@keepeek/commons";
import { DownloadManagerCSUContent } from "@keepeek/refront-components";
import { selectorFamily } from "recoil";

import { downloadManagerFetcherSelector } from "../../fetcher/selectors/downloadManager";
import { convertKpkApiMediaTermsOfUsesToDownloadManagerCSUContents } from "../utils";

export const downloadCSUSelector = selectorFamily<DownloadManagerCSUContent[], string | null>({
  key: "downloadCGUSelector",
  get:
    (selectionId) =>
    async ({ get }) => {
      if (selectionId === null) {
        return [];
      }
      const { getSelectionMediasTermsOfUse } = get(
        downloadManagerFetcherSelector(get(fetcherModeAtom)),
      );

      const user = get(currentUserQuery);
      const getSelectionMediasTermsOfUseQuery = await getSelectionMediasTermsOfUse({
        selectionId,
        userId: user.id,
      });
      if (!getSelectionMediasTermsOfUseQuery) {
        return [];
      }
      const { data } = getSelectionMediasTermsOfUseQuery;
      const apiTermsOfUse = data._embedded?.["media-terms-of-use"];
      return apiTermsOfUse !== undefined
        ? convertKpkApiMediaTermsOfUsesToDownloadManagerCSUContents(apiTermsOfUse)
        : [];
    },
});
